import { render } from "./Spinner.vue?vue&type=template&id=e4f3de7e&scoped=true"
const script = {}

import "./Spinner.vue?vue&type=style&index=0&id=e4f3de7e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-e4f3de7e"

export default script